import React, { lazy } from 'react';
export function FinalCTASection() {
  const handleScrollToBonuses = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector('#bonuses');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="bg-gradient-to-br from-[#3D2B1F] to-[#6B4C3B] text-[#FAF7F2] py-16 px-5 text-center" data-id="element-131">
      <div className="max-w-[900px] mx-auto" data-id="element-132">
        <h2 className="text-4xl md:text-5xl text-[#FAF7F2] mb-4" data-id="element-133">
          Tu Bebé No Puede Esperar.
        </h2>

        {/* Emotional closing image */}
        <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Momento_intimo_con_un_toque_de_luz.png?v=1775551284" alt="Momento íntimo con bebé" width="700" height="467" loading="lazy" decoding="async" className="w-[92%] md:w-[60%] md:max-w-[700px] mx-auto my-7 block rounded-3xl shadow-[0_12px_35px_rgba(61,43,31,0.12)] border border-[rgba(183,110,121,0.15)] hover:scale-[1.02] transition-transform duration-300" style={{
        aspectRatio: '3/2'
      }} data-id="element-134" />

        <p className="text-lg text-[rgba(250,247,242,0.8)] font-sans max-w-[600px] mx-auto mb-9 leading-relaxed" data-id="element-135">
          Cada día que pasa sin el sistema correcto es una ventana neurológica
          que se cierra. El primer año no se repite. La decisión es ahora.
        </p>

        <a href="#bonuses" onClick={handleScrollToBonuses} className="inline-block bg-gradient-to-r from-[#C9A96E] to-[#B76E79] text-white text-lg font-bold py-5 px-12 rounded-full tracking-wide shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse mb-6" data-id="element-136">
          ⚡ ACTIVAR MI ACCESO COMPLETO →
        </a>

        <div className="flex justify-center gap-5 flex-wrap text-sm text-[rgba(250,247,242,0.6)] font-sans" data-id="element-137">
          <span className="flex items-center gap-1.5" data-id="element-138">🔒 Pago Seguro SSL</span>
          <span className="flex items-center gap-1.5" data-id="element-139">📥 Acceso Inmediato</span>
          <span className="flex items-center gap-1.5" data-id="element-140">
            ↩️ Garantía de 30 Días
          </span>
        </div>
      </div>
    </section>;
}